import { render, staticRenderFns } from "./StaticDateHeaderDispatchPanel.vue?vue&type=template&id=5dc88719"
import script from "./StaticDateHeaderDispatchPanel.vue?vue&type=script&lang=js"
export * from "./StaticDateHeaderDispatchPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports